export class MissingAdminRouteTokenError extends Error {
  constructor() {
    super("Admin route context is missing an access token");
    this.name = "MissingAdminRouteTokenError";
  }
}
